import { useEffect, useState } from "react";
import { useApiContext } from 'context/ApiContext';

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDPopup from "components/MDPopup";

// Material Dashboard 2 React example components
import DataTable from "examples/Tables/DataTableV2";

function UserTab({ users }) {
    const { userFormInfosAdm, setUserFormInfosAdm, APIRequestType, getAPI, postAPI } = useApiContext();

    // Récupération de l'ID utilisateur dans localStorage
    const userID = localStorage.getItem('userID');
    const userRole = localStorage.getItem('userRole');

    const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
    const [selectedUserToDelete, setSelectedUserToDelete] = useState(null);

    const [hoveredInactive, setHoveredInactive] = useState(false);

    const handleOpenDeleteDialog = (item) => {
        setSelectedUserToDelete(item);
        setOpenDeleteDialog(true);
    };
    const handleCloseDeleteDialog = () => {
        setSelectedUserToDelete(null);
        setOpenDeleteDialog(false);
    };

    const modifyUser = (item, userStatus) => {
        postAPI({
            requestType: APIRequestType.MODIFY_USER,
            email: item.email,
            phone: item.phone,
            name: item.name,
            lastName: item.lastName,
            pswd: null,
            role: item.role,
            status: userStatus,
            userId: item.id,
            updateParkList: false,
            pageRequest: "UserForm"
        });
    };
    const resetUserTab = () => {
        setUserFormInfosAdm({
            selectedUser: null,
            formType: "Tab",
        });
    }

    const handleConfirmDelete = (item) => {
        console.log("User DELETE:", selectedUserToDelete);
        modifyUser(item, "INACTIVE");
        resetUserTab();
        setOpenDeleteDialog(false);
    };
    const handleActiveUser = (item) => {
        console.log("ACTIVE User:", item.id);
        modifyUser(item, "ACTIVE");
        resetUserTab();
        setHoveredInactive(null);
    };

    const handleCreateUser = () => {
        setUserFormInfosAdm({
            selectedUser: null,
            formType: "CreateUser",
        });
        console.log("Selected USER to Create");
    };
    const handleModifyUser = (item) => {
        setUserFormInfosAdm({
            selectedUser: item,
            formType: "ModifyUser",
        });
        console.log("Selected USER to Modify:", item);
    };
    const handleVisualizeUser = (item) => {
        setUserFormInfosAdm({
            selectedUser: item,
            formType: "VisualizeUser",
        });
        console.log("Selected USER to Visualize:", item);
    };

    const formatPhoneNumber = (phone) => {
        if (!phone) return "";

        // Supprimer tous les caractères non numériques
        let cleaned = phone.replace(/\D/g, "");
        // Si le numéro commence par 0033, on retire les 4 premiers caractères
        if (cleaned.startsWith("0033")) {
            cleaned = cleaned.slice(4);
        }
        // S'assurer de ne garder que les 9 derniers chiffres
        cleaned = cleaned.slice(-9);
        return cleaned;
    };

    return (
        <MDBox pt={4} pb={3}>
            <Grid container spacing={6}>
                <Grid item xs={12}>
                    <Card>
                        <MDBox
                            mx={2}
                            mt={-3}
                            py={1.5}
                            px={2}
                            variant="gradient"
                            bgColor="info"
                            borderRadius="lg"
                            coloredShadow="info"
                        >
                            <MDTypography variant="h6" color="white"> Users </MDTypography>
                        </MDBox>
                        <MDBox pt={2} pr={2} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                            <MDButton
                                onClick={() => handleCreateUser()}
                                sx={{
                                    '&:hover': {
                                        backgroundColor: "#b7e4fd", // Couleur au survol
                                    },
                                }}
                            >
                                <MDBox
                                    sx={{ display: 'flex', alignItems: 'center', gap: 1 }}
                                >
                                    <MDTypography
                                        variant="h7"
                                        color="dark"
                                        fontWeight="medium"
                                        sx={{ mt: 0.2 }}
                                    >
                                        ADD NEW
                                    </MDTypography>
                                    <Icon color="text" fontSize="large" sx={{ mt: -0.1 }}> add </Icon>
                                </MDBox>
                            </MDButton>
                        </MDBox>
                        <MDBox>
                            <DataTable
                                table={{
                                    columns: [
                                        { Header: "Name", accessor: "name", align: "left" },
                                        { Header: "Email", accessor: "email", align: "left" },
                                        { Header: "Phone", accessor: "phone", align: "left" },
                                        { Header: "Role", accessor: "role", align: "center" },
                                        { Header: "", accessor: "icon", align: "right" },
                                    ],
                                    rows: users
                                        .filter(user => {
                                            if (userRole !== "AdminAT") {
                                                if (user.role === "AdminAT" || user.status === "INACTIVE") {
                                                    return false;
                                                } else {
                                                    return true;
                                                }
                                            } else {
                                                return true;
                                            }
                                        })
                                        .map((user) => {
                                            const isInactive = user.status === "INACTIVE";
                                            const isCurrentUser = parseInt(user.id) === parseInt(userID);
                                            const isSameRole = user.role === userRole;
                                            const isRoleAT = userRole === "AdminAT";

                                            return {
                                                nameValue: user.name,
                                                lastNameValue: user.lastName,
                                                emailValue: user.email,
                                                phoneValue: formatPhoneNumber(user.phone),
                                                roleValue: user.role,
                                                isInactive: user.status === "INACTIVE",

                                                name: (
                                                    <MDTypography component="a" href="#" variant="caption" color="text" fontWeight="medium">
                                                        {user.name + " " + user.lastName}
                                                    </MDTypography>
                                                ),
                                                email: (
                                                    <MDTypography component="a" href="#" variant="caption" color="text" fontWeight="medium">
                                                        {user.email}
                                                    </MDTypography>
                                                ),
                                                phone: (
                                                    <MDTypography component="a" href="#" variant="caption" color="text" fontWeight="medium">
                                                        +33 {formatPhoneNumber(user.phone)}
                                                    </MDTypography>
                                                ),
                                                role: (
                                                    <MDTypography component="a" href="#" variant="caption" color="text" fontWeight="medium">
                                                        {user.role}
                                                    </MDTypography>
                                                ),
                                                icon: (
                                                    <MDBox>
                                                        {isInactive ? (
                                                            <MDTypography
                                                                variant="caption"
                                                                color="secondary"
                                                                fontWeight="medium"
                                                                sx={{
                                                                    cursor: 'pointer',
                                                                    '&:hover': {
                                                                        color: '#b7e4fd',
                                                                    },
                                                                }}
                                                                onMouseEnter={() => setHoveredInactive(user.id)}
                                                                onMouseLeave={() => setHoveredInactive(null)}
                                                                onClick={() => handleActiveUser(user)}
                                                            >
                                                                {hoveredInactive === user.id ? 'ACTIVATE' : 'INACTIVE'}
                                                            </MDTypography>
                                                        ) : (
                                                            <>
                                                                {!isSameRole && (
                                                                    <>
                                                                        <Icon
                                                                            fontSize="small"
                                                                            sx={{
                                                                                mt: -0.25,
                                                                                mr: 3,
                                                                                '&:hover': { color: "#b7e4fd", cursor: "pointer" }
                                                                            }}
                                                                            onClick={() => handleOpenDeleteDialog(user)}
                                                                        >
                                                                            delete
                                                                        </Icon>
                                                                    </>
                                                                )}
                                                                {(isRoleAT || !isSameRole) && (
                                                                    <>
                                                                        <Icon
                                                                            fontSize="small"
                                                                            sx={{
                                                                                mt: -0.25,
                                                                                mr: 3,
                                                                                '&:hover': { color: "#b7e4fd" }
                                                                            }}
                                                                            onClick={() => handleModifyUser(user)}
                                                                        >
                                                                            drive_file_rename_outline
                                                                        </Icon>
                                                                    </>
                                                                )}
                                                                <Icon
                                                                    fontSize="small"
                                                                    sx={{
                                                                        mt: -0.25,
                                                                        '&:hover': { color: "#b7e4fd" }
                                                                    }}
                                                                    onClick={() => handleVisualizeUser(user)}
                                                                >
                                                                    visibility
                                                                </Icon>
                                                            </>
                                                        )}
                                                    </MDBox>
                                                ),
                                            };
                                        }),
                                }}
                                rowsNumberPerPage={7}
                                isSorted={false}
                                entriesPerPage={false}
                                showTotalEntries={false}
                                noEndBorder
                            />
                        </MDBox>
                    </Card>
                </Grid>
            </Grid>

            <MDPopup
                open={openDeleteDialog}
                onClose={handleCloseDeleteDialog}
                onConfirm={() => handleConfirmDelete(selectedUserToDelete)}
                item={selectedUserToDelete}
                title="Confirm Deletion"
                body={(item) => (
                    <>
                        Are you sure you want to delete the user <strong>{item?.name} {item?.lastName}</strong>?
                    </>
                )}
                confirmLabel="Delete"
                cancelLabel="Cancel"
                showConfirmButton={true}
                showCancelButton={true}
            />
        </MDBox >
    );
}

export default UserTab;